export default class BackgroundText {


	// Constructor
	constructor(asscroll, element) {
		this.asscroll = asscroll;
		this.element = element;
		this.text = this.element.querySelector('.background-text');
		this.scroll = this.scroll.bind(this);
	}


	// Public Methods
	destroy() {
		this.disable();
		delete this.asscroll;
		delete this.element;
		delete this.text;
	}
	enable() {
		this.asscroll.on('update', this.scroll);
	}
	disable() {
		this.asscroll.off('update', this.scroll);
	}


	// Event Handlers
	scroll() {
		const { top } = this.element.getBoundingClientRect();
		const windowHeight = window.innerHeight;
		const pos = (windowHeight * 0.5) - top;
		this.text.style.transform = `translate3d(-50%, -50%, 0) translate3d(0, ${pos}px, 0)`;
	}


}
